import _ from 'lodash';
import { Utils as CommonUtils } from '../js/Utils';

export class Utils {
  static getStateList() {
    return [
      { value: 'AL', description: 'Alabama' },
      { value: 'AK', description: 'Alaska' },
      { value: 'AZ', description: 'Arizona' },
      { value: 'AR', description: 'Arkansas' },
      { value: 'CA', description: 'California' },
      { value: 'CO', description: 'Colorado' },
      { value: 'CT', description: 'Connecticut' },
      { value: 'DE', description: 'Delaware' },
      { value: 'DC', description: 'District Of Columbia' },
      { value: 'FL', description: 'Florida' },
      { value: 'GA', description: 'Georgia' },
      { value: 'HI', description: 'Hawaii' },
      { value: 'ID', description: 'Idaho' },
      { value: 'IL', description: 'Illinois' },
      { value: 'IN', description: 'Indiana' },
      { value: 'IA', description: 'Iowa' },
      { value: 'KS', description: 'Kansas' },
      { value: 'KY', description: 'Kentucky' },
      { value: 'LA', description: 'Louisiana' },
      { value: 'ME', description: 'Maine' },
      { value: 'MD', description: 'Maryland' },
      { value: 'MA', description: 'Massachusetts' },
      { value: 'MI', description: 'Michigan' },
      { value: 'MN', description: 'Minnesota' },
      { value: 'MS', description: 'Mississippi' },
      { value: 'MO', description: 'Missouri' },
      { value: 'MT', description: 'Montana' },
      { value: 'NE', description: 'Nebraska' },
      { value: 'NV', description: 'Nevada' },
      { value: 'NH', description: 'New Hampshire' },
      { value: 'NJ', description: 'New Jersey' },
      { value: 'NM', description: 'New Mexico' },
      { value: 'NY', description: 'New York' },
      { value: 'NC', description: 'North Carolina' },
      { value: 'ND', description: 'North Dakota' },
      { value: 'OH', description: 'Ohio' },
      { value: 'OK', description: 'Oklahoma' },
      { value: 'OR', description: 'Oregon' },
      { value: 'PA', description: 'Pennsylvania' },
      { value: 'RI', description: 'Rhode Island' },
      { value: 'SC', description: 'South Carolina' },
      { value: 'SD', description: 'South Dakota' },
      { value: 'TN', description: 'Tennessee' },
      { value: 'TX', description: 'Texas' },
      { value: 'UT', description: 'Utah' },
      { value: 'VT', description: 'Vermont' },
      { value: 'VA', description: 'Virginia' },
      { value: 'WA', description: 'Washington' },
      { value: 'WV', description: 'West Virginia' },
      { value: 'WI', description: 'Wisconsin' },
      { value: 'WY', description: 'Wyoming' },
    ];
  }

  static getChildTypes() {
    return [
      { value: 'all', description: 'All lawful children' },
      { value: 'marriage', description: 'Children of a specific marriage' },
    ];
  }

  static getPerStirpesOptions() {
    return [
      { value: 'perstirpeYes', description: 'Yes' },
      { value: 'perstirpeNo', description: 'No' },
    ];
  }

  static checkSum(routing: number) {
    if (routing) {
      const routingArr = routing.toString().split('');
      let res: number = 0;
      for (let i = 0; i < 9; i++) {
        const currNumber = Number(routingArr[i]);
        if (i === 0 || i === 3 || i === 6) {
          res += currNumber * 3;
        }
        if (i === 1 || i === 4 || i === 7) {
          res += currNumber * 7;
        }
        if (i === 2 || i === 5 || i === 8) {
          res += currNumber * 1;
        }
      }
      return res % 10 ? false : true;
    }
    return true;
  }

  static validatePhone(phoneNumber: string) {
    let isValid = true;

    if (!phoneNumber || phoneNumber.length < 10 || phoneNumber.match(/\D/)) {
      isValid = false;
    }

    if (phoneNumber.length > 10) {
      const ext = phoneNumber.length > 10 ? ' ' + phoneNumber.substr(10) : '';

      if (ext.length > 11) {
        isValid = false;
      }
    }

    return isValid;
  }

  static formatPhoneEdit(phoneNum: string): string {
    if (phoneNum) {
      if (phoneNum === '') {
        return phoneNum;
      }
      const numbers = phoneNum.replace(/\D/g, '');
      if (numbers.length === 10) {
        return '(' + numbers.substring(0, 3) + ') ' + numbers.substring(3, 6) + '-' + numbers.substring(6);
      } else if (numbers.length > 10) {
        return (
          '(' +
          numbers.substring(0, 3) +
          ') ' +
          numbers.substring(3, 6) +
          '-' +
          numbers.substring(6, 10) +
          ' x' +
          numbers.substring(10)
        );
      }
    } else {
      return null;
    }
  }

  static formatGovtIdEdit(idNum: string, govtIdType: string): string {
    if (idNum) {
      if (idNum === '') {
        return idNum;
      }
      const numbers = idNum.replace(/\D/g, '');
      if (govtIdType === 'itin') {
        return numbers.substring(0, 2) + '-' + numbers.substring(2);
      } else if (govtIdType === 'ssn') {
        return numbers.substring(0, 3) + '-' + numbers.substring(3, 5) + '-' + numbers.substring(5);
      }
    } else {
      return null;
    }
  }

  static getPerstirpe(beneType: string): string {
    if (beneType === '9' || beneType === '1') {
      return null;
    }
    if (beneType.indexOf('-1') !== -1) {
      return 'perstirpeYes';
    } else {
      return 'perstirpeNo';
    }
  }

  static deriveDob(dob: string): string {
    let derivedDob = dob;

    if (dob && dob.toString().indexOf('T') !== -1) {
      derivedDob = dob.toString().substring(0, dob.toString().indexOf('T'));
    }

    return derivedDob || '';
  }

  static getPAPerstirpe(beneficiaryType: string): string {
    if (beneficiaryType.split('-')[1] === '1') {
      return 'Yes';
    } else if (beneficiaryType.split('-')[1] === '2') {
      return 'No';
    } else {
      return 'Not Specified';
    }
  }

  static getPABeneficiaryType(beneficiaryType: string) {
    return beneficiaryType.split('-')[0];
  }
}
